import { NgModule } from "@angular/core";
import { NgxPaginationModule } from "ngx-pagination";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { LoadingModule } from "ngx-loading";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgxPermissionsModule } from "ngx-permissions";
import { RouterModule } from "@angular/router";

import { routes } from "./oes.routing";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { PipesModule } from "../pipes/pipes.module";
import { TableModule } from "primeng/table";
import { InputTextModule } from "primeng/inputtext";
import { AppTableComponent } from "../../components/app-table";
import { DropdownModule } from "primeng/dropdown";
import { MasterDataService } from "./services/master-data.service";
import { MasterDataComponent } from "./master-data/master-data.component";
import { MasterDataFormComponent } from "./master-data/master-data-form/master-data-form.component";
import { RackService } from "./services/rack.service";
import { RackComponent } from "./rack/rack.component";
import { RackFormComponent } from "./rack/rack-form/rack-form.component";
import { MasterCustomerService } from "./services/master-customer.service";
import { MasterCustomerComponent } from "./master-customer/master-customer.component";
import { PlantService } from "./services/plant.service";
import { PlantComponent } from "./plant/plant.component";
import { PlantFormComponent } from "./plant/plant-form/plant-form.component";
import { SharedModule } from "../../modules/shared.module";
import { ScannedDataComponent } from "./scanned-data/scanned-data.component";
import { ScannedDataFormComponent } from "./scanned-data/scanned-data-form/scanned-data-form.component";
import { ScannedDataService } from "./services/scanned-data.service";
import { QuickOrderComponent } from "./quick-order/quick-order.component";
import { MasterDataSelectionModalComponent } from "./master-data-selection-modal/master-data-selection-modal.component";
import { PartsUsageService } from "./services/parts-usage.service";
import { PartUsageComponent } from "./part-usage/part-usage.component";
import { QuickOrderEditComponent } from "./quick-order/quick-order-edit/quick-order-edit.component";
import {
  MatAutocompleteModule,
  MatDialogModule,
  MatRadioModule,
} from "@angular/material";
import { OverlayPanelModule, TooltipModule } from "primeng/primeng";
import { UsageReportComponent } from "./usage-report/usage-report.component";
import { MasterDataImportQueueComponent } from "./master-data/master-data-import-queue/master-data-import-queue.component";
import { UsageStatsComponent } from "./usage-stats/usage-stats.component";
import { AppColoredLabelModule } from "../../components/app-colored-label/app-colored-label.module";
import { UnityChartModule } from "../../components/unity-chart/unity-chart.module";
import { AppSpinnerDivModule } from "../../components/app-spinner-div/app-spinner-div.module";
import { LocalDatePipe } from "../pipes/local-date.pipe";
import { DisplayFieldPipe } from "../pipes/displayField.pipe";
import { CurrencyPipe } from "@angular/common";
import { UsageMonthlyComponent } from "./usage-monthly/usage-monthly.component";
import { TableExtensionService } from "./table-extension.service";

@NgModule({
  imports: [
    ReactiveFormsModule,
    CommonModule,
    FormsModule,
    NgMultiSelectDropDownModule,
    NgxPaginationModule,
    NgxDatatableModule,
    LoadingModule,
    NgxPermissionsModule.forChild(),
    NgbModule,
    RouterModule.forChild(routes),
    PipesModule,
    // MaterialModule,
    TableModule,
    InputTextModule,
    DropdownModule,
    // MatAutocompleteModule,
    SharedModule,
    MatDialogModule,
    TooltipModule,
    MatAutocompleteModule,
    OverlayPanelModule,
    AppColoredLabelModule,
    MatRadioModule,
    UnityChartModule,
    AppSpinnerDivModule,
  ],
  providers: [
    MasterDataService,
    RackService,
    PlantService,
    MasterCustomerService,
    ScannedDataService,
    PartsUsageService,
    LocalDatePipe,
    DisplayFieldPipe,
    CurrencyPipe,
    TableExtensionService,
  ],
  declarations: [
    AppTableComponent,
    // WorkspaceSelectComponent,
    MasterDataComponent,
    MasterDataFormComponent,
    MasterDataImportQueueComponent,
    RackComponent,
    RackFormComponent,
    PlantComponent,
    PlantFormComponent,
    MasterCustomerComponent,
    QuickOrderComponent,
    MasterDataSelectionModalComponent,
    ScannedDataComponent,
    ScannedDataFormComponent,
    PartUsageComponent,
    QuickOrderEditComponent,
    UsageReportComponent,
    UsageStatsComponent,
    UsageMonthlyComponent,
  ],
  entryComponents: [MasterDataSelectionModalComponent, QuickOrderEditComponent],
})
export class OesModule {}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/oes/oes.module.ts